__turbopack_context__.v({
  "className": "onest_15b3d2f9-module__EBo5gW__className",
  "variable": "onest_15b3d2f9-module__EBo5gW__variable",
});
